import { render, staticRenderFns } from "./BatchManager.vue?vue&type=template&id=64168b06&scoped=true&"
import script from "./BatchManager.vue?vue&type=script&lang=js&"
export * from "./BatchManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64168b06",
  null
  
)

export default component.exports